export interface CharacterizationOption {
  tag: string;
  description: string;
}

export const CHARACTERIZATION_ENABLED_FLAG = 'characterization_enabled';

export function parseCharacterizationOptions(data: unknown): CharacterizationOption[] {
  const record = data as
    | {
        content?: {
          assessment_spec?: {
            llm_assessment?: {
              characterization_options?: Array<Record<string, string>>;
            };
          };
        };
      }
    | undefined;
  const rawOptions = record?.content?.assessment_spec?.llm_assessment?.characterization_options;
  if (!Array.isArray(rawOptions) || rawOptions.length === 0) {
    return [{ tag: '', description: '' }];
  }

  const options = rawOptions.map(option => {
    const tag = Object.keys(option)[0] || '';
    return { tag, description: option[tag] || '' };
  });
  return options.length > 0 ? options : [{ tag: '', description: '' }];
}

export function areCharacterizationOptionsValid(options: CharacterizationOption[]): boolean {
  const hasValidOptions = options.every(option => option.tag.trim() && option.description.trim());
  if (!hasValidOptions) return false;
  const tags = options.map(option => option.tag.trim());
  return new Set(tags).size === tags.length;
}

export function buildCharacterizationDataPayload(
  name: string,
  options: CharacterizationOption[]
): {
  name: string;
  content: Record<string, unknown>;
} {
  const formattedOptions = options.map(option => ({
    [option.tag]: option.description,
  }));

  return {
    name,
    content: {
      assessment_spec: {
        workflow_stage: 'post_generator',
        llm_assessment: {
          model: 'openai-gpt-4o-mini',
          output_format: '{str <option_name>: float <score>}',
          system_prompt: 'default_characterization_prompt',
          options_format: 'list[dict]',
          characterization_options: formattedOptions,
        },
        assessment_method: 'llm_assessment',
      },
      workflow_actions: [
        {
          action_type: 'tag_utterance_characterization',
          trigger_condition: {
            score_threshold: 0.5,
          },
        },
      ],
    },
  };
}
